<template>
  <div id="quote-extraction-page">
    <page-header-component v-if="topics" icon="bi bi-chat-quote" title="Ekstraksi Kutipan" :topics="topics"
      class="mb-2" />
    <!-- <div class="px-2">
      <div id="tab" class="card card-default shade">
        <div class="card-body">
          <ul
            class="nav nav-tabs nav-tabs-simple d-md-flex d-lg-flex d-xl-flex"
            role="tablist"
            data-init-reponsive-tabs="dropdownfx"
          >
            <li class="nav-item" @click="switchTab('Kol')">
              <a
                class="active"
                data-toggle="tab"
                role="tab"
                data-target="#tab2hellowWorld"
                href="#"
                aria-selected="true"
              >
                <i class="bi bi-person-vcard" /> Kol/ Entity
              </a>
            </li>
            <li class="nav-item" @click="switchTab('Raw')">
              <a
                href="#"
                data-toggle="tab"
                role="tab"
                data-target="#tab2FollowUs"
                class=""
                aria-selected="false"
              >
                <i class="bi bi-person-badge" /> Data Mentah
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <tab-kol-entity-component v-if="current_tab == 'Kol'" />
    <tab-data-mentah-component v-else />
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import tab_kol_entity from "@/views/components/quotes-extraction/tab_kol_entity.vue";
import tab_data_mentah from "@/views/components/quotes-extraction/tab_data_mentah.vue";

export default {
  name: "QuotesExtraction",
  title: "Analitik Ekstraksi Kutipan | Sibernetik",
  components: {
    "page-header-component": page_header,
    "tab-kol-entity-component": tab_kol_entity,
    "tab-data-mentah-component": tab_data_mentah,
  },
  data() {
    return {
      current_tab: "Raw",
      id_project: this.$store.getters.user.id_project,
      topics: null,
    };
  },
  methods: {
    switchTab: function (component) {
      this.current_tab = component;
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.topics = response.data;
        } else {
          this.topics = {};
        }
      });
    },
  },
  created() {
    this.getTopic();
  },
};
</script>
